// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.rewards.EnrollRewardsUserWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { EnrollRewardsUserWebApiHandler_enrollUser } from '@zg-rentals/ts-rent-payment-client';

import type { EnrollRewardsUserWebApiResponseDto } from '@zg-rentals/ts-rent-payment-client';

export type EnrollRewardsUserWebApiHandler_enrollUser_Options = UseMutationOptions<
  EnrollRewardsUserWebApiResponseDto,
  unknown,
  void
>;

/**
 * enroll user into rewards program
 */
export const useEnrollRewardsUserWebApiHandler_enrollUser = ({
  httpClient,
  ...options
}: Omit<EnrollRewardsUserWebApiHandler_enrollUser_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => EnrollRewardsUserWebApiHandler_enrollUser(httpClient),
  });
};
